module.exports = __webpack_public_path__ + "static/img/a117.2a9883d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a117.jpg
// module id = cLPk
// module chunks = 0